import { createContext } from 'react'

import { PersonalTrainer } from '~/modules/admin/types'

type ContextData = {
  personalTrainer: PersonalTrainer
}

export const context = createContext<ContextData>({} as ContextData)
